import { render } from "./custom-money-dialog-view.vue?vue&type=template&id=277984b6&scoped=true&ts=true"
import script from "./custom-money-dialog-view.vue?vue&type=script&lang=ts"
export * from "./custom-money-dialog-view.vue?vue&type=script&lang=ts"

import "./custom-money-dialog-view.vue?vue&type=style&index=0&id=277984b6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277984b6"]])

export default __exports__